/* 
// Cart Drawer
*/
jQuery('.cart-opener').on('click', function() {
    jQuery('body').addClass('js-my-cart-open');
});

jQuery('.close-cart').on('click', function() {
    jQuery('body').removeClass('js-my-cart-open');
});

jQuery(".page-content").on("click",function(e) {
    var cl = document.body.classList;
    var tl = e.currentTarget.classList;

    if (tl.contains('cart-wrapper')) {
        // nothing
    } else {

        if (cl.contains('js-my-cart-open')) {
            cl.remove('js-my-cart-open');
        }

    }
});


/* 
// Overlay Menu
*/
jQuery('.open-menu').on('click', function() {
    jQuery('.overlay-menu').addClass('open');
    jQuery('.menu-button').css('display', 'none');
    jQuery('.close-menu').css('display', 'flex');
});

jQuery('.close-menu').on('click', function() {
    jQuery('.overlay-menu').removeClass('open');
    jQuery('.menu-button').css('display', 'flex');
    jQuery('.close-menu').css('display', 'none');
});